export default function startVisitTracking(recordVisit: () => Promise<unknown>): () => void {
    let interval: number | undefined;

    const sendVisit = async () => {
        if (document.visibilityState !== 'visible') {
            return;
        }

        try {
            await recordVisit();
        } catch {
            // Presence reporting must not interrupt the app; wait for the next eligible update.
        }
    };

    const stopInterval = () => {
        window.clearInterval(interval);
        interval = undefined;
    };

    const updateVisibility = () => {
        if (document.visibilityState !== 'visible') {
            stopInterval();
            return;
        }

        if (interval !== undefined) {
            return;
        }

        void sendVisit();
        interval = window.setInterval(sendVisit, 60000);
    };

    document.addEventListener('visibilitychange', updateVisibility);
    updateVisibility();

    return () => {
        stopInterval();
        document.removeEventListener('visibilitychange', updateVisibility);
    };
}
